(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/header.js');
"use strict";


const {
  Image
} = svs.content.image_v2;
const {
  useRef
} = React;
const {
  useHistory
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  trackClickPlayLyckoplatsen
} = svs.lyckoplatsen.page_start;
const {
  heroImage,
  heroHeader,
  heroGuideLinkColor
} = svs.lyckoplatsen.data.hero;
const {
  HeaderTextSlider
} = svs.lyckoplatsen.components.page_start.react.components;
const Header = () => {
  const history = useHistory();
  const headerRef = useRef(null);
  const handlePlayClick = () => {
    trackClickPlayLyckoplatsen(true);
    history.push('/spela');
  };
  const orientation = svs.lyckoplatsen.hooks.useOrientationDetect();
  const theImage = orientation === 'landscape' ? heroImage.LANDSCAPE : heroImage.PORTRAIT;
  const handleScrollTo = () => {
    if (headerRef.current) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const targetPos = headerRef.current.getBoundingClientRect().bottom + window.scrollY - headerHeight;
      window.scrollTo({
        top: targetPos,
        behavior: 'smooth'
      });
    }
  };
  return React.createElement("div", {
    className: "lp-page-start-header",
    ref: headerRef
  }, React.createElement("div", {
    className: "lp-page-start-header-content f-content"
  }, React.createElement("h1", {
    style: (heroHeader === null || heroHeader === void 0 ? void 0 : heroHeader.color) === 'fc-white' ? {
      color: 'white'
    } : undefined
  }, (heroHeader === null || heroHeader === void 0 ? void 0 : heroHeader.header) || ''), React.createElement(HeaderTextSlider, null), React.createElement(Button, {
    className: "lp-green",
    onClick: handlePlayClick,
    size: 500
  }, "Spela Lyckoplatsen"), React.createElement("div", {
    className: "lp-guide-button",
    type: "button",
    onClick: handleScrollTo
  }, React.createElement("p", {
    className: "h4",
    style: heroGuideLinkColor === 'fc-white' ? {
      color: 'white'
    } : undefined
  }, "S\xE5 funkar Lyckoplatsen"), React.createElement(Icon, {
    size: "600",
    color: heroGuideLinkColor,
    icon: "menu-down"
  }))), React.createElement(Image, {
    cssSelectors: "lp-hero-multi-image background-image-wrapper image-wrapper-fit",
    image: theImage
  }));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  Header
});

 })(window);